import { Component, OnInit, NgZone } from '@angular/core';
import {Title} from '@angular/platform-browser';
import {TagService} from '../../services/tag-service.service';
import {TopicService} from '../../services/topic.service';
import {Tag} from '../tag/model/tag';
import {Topic} from '../topic/model/topic';
import {Observable} from 'rxjs/Rx';
import {HostListener} from '@angular/core';
import {ActivatedRoute, Router } from '@angular/router';
import {UserService} from '../../services/user.service';
import {Login} from '../../services/user.service';
declare function escape(s:string): string;
declare function unescape(s:string): string;

declare function testJs(): any;

@HostListener('window:keydown', ['$event'])
@Component({
  host: {
    '(document:keydown)': 'keyDown($event)',
  },
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.css'],
})

export class ChatComponent implements OnInit {
  public LOGO = require("../../../assets/donut.png");
  tags: Tag[];
  topics: Topic[];
  public topic = new Topic('', '', '');
  utags: any;
  public model = new Tag('', '', '', '');
  private umodel = new Tag('', '', '', '');
  public selectedTag;
  classTag = "Not Selected Yet";
  selectedIndex = 0;
  message = "";
  searchText = "";
  currentPage = 0;
  pageSize = 10;
  pageDirection = -1;
  totalCount = 0;
  pageCount = 0;
  sortKey = "insertdate";
  selectAll = false;
  theUser: string;
  //twt: string;

  constructor(private titleService: Title, private ngZone: NgZone, private tagService: TagService, private topicService: TopicService, private activatedRoute: ActivatedRoute, private userSVC: UserService, private router: Router){} 

  ngOnInit() { 
    this.theUser = this.userSVC.authUser.email;
    if (!this.theUser) {
      this.router.navigate(['']);
    }

    this.activatedRoute.queryParams.subscribe(params => {
      this.model.hashTag = params['h'] || "";
      this.topic.hashTag = this.model.hashTag;
    });
    if(this.model.hashTag) {
      this.titleService.setTitle(this.topic.hashTag);
      this.setFirstPage();
      //        this.open();
    }

    window['angularComponentReference'] = { component: this, zone: this.ngZone, ldUpdateTopicAndNavigate: () => this.ngUpdateTopicAndNavigate(), };
  }

  selectedText: string = '';

  showSelectedText(oField) {
    var text = "";
    if (window.getSelection) {
      text = window.getSelection().toString();
      //    } else if (document.selection && document.selection.type != "Control") {
      //text = document.selection.createRange().text;
    }
    this.selectedText = text;
  }

  loadTags(callback: () => any) {
    //this.getTopicUserTags(callback);
    this.tagService.filterTags(this.model.hashTag, this.model.source, this.model.value, this.sortKey, this.theUser)
      .subscribe(
        tags => {
          this.tags = tags; //Bind to view
          if(this.tags !== undefined) {
            this.totalCount = this.tags.length;
            this.pageCount = Math.ceil(this.totalCount / this.pageSize);
            if(callback !== undefined) {
              callback();
            }
            for (let i = 0; i < this.tags.length; i++) {
              this.renderTag(this.tags[i]);
            }
            this.setPageVisible();
          }
        },
        err => {
          console.log(err);
        });
  }

  getTopicUserTags(callback: () => any) {
    this.tagService.getTopicUserTags(this.model.hashTag, this.theUser)
      .subscribe(
        tags => {
          this.tags = tags; //Bind to view
          if(this.tags !== undefined) {
            this.totalCount = this.tags.length;
            this.pageCount = Math.ceil(this.totalCount / this.pageSize);
            if(callback !== undefined) {
              callback();
            }
            this.setPageVisible();
          }
        },
        err => {
          console.log(err);
        });
  }

  submitTag(){
    if (this.model.hashTag === "" || this.model.hashTag.toLowerCase() === "untitled topic") {
      return;
    }

    let commentOperation:Observable<Tag[]>;
    if (this.model.value === "" )
    {
      return;
    }

    var t = new Tag(this.model.hashTag, '', '', '')
    t.hashTag = this.model.hashTag;
    t.value = this.model.value;

    if (t.value.startsWith("<<<")) { 
        var ix = this.classTag.lastIndexOf(">>>");
        if (ix > 0) {
          this.classTag = this.classTag.substring(0, ix);
        } else if (ix === 0) {
          this.classTag = "Not Selected Yet";
        }

      if (t.value.length > 3) { 
        if (this.classTag === "" || this.classTag === "Not Selected Yet") {
          this.classTag = ">>>" + t.value.substring(3, t.value.length);
        } else {
          this.classTag += ">>>" + t.value.substring(3, t.value.length);
        }
      }
      this.model.value = "";

      return;
    }

    if (t.value.startsWith(">>>")) { 
      if (t.value.length > 3) { 
        if (this.classTag === "Not Selected Yet") {
          this.classTag = t.value;
        } else {
          this.classTag += t.value;
        }
    } else {
      this.classTag = "Not Selected Yet";
    }
    this.model.value = "";

    return;
  } 

  if(this.classTag && this.classTag !== "Not Selected Yet") {
    t.hashTag = t.hashTag+this.classTag;
  }

  t.email = this.theUser;
  t.source = this.theUser;
  this.tagService.addTag(t).subscribe(
    () => {
      this.model = new Tag(this.model.hashTag, '', '', '');
      this.setFirstPage();
    },
    err => {
      console.log(err);
    });
}

  renderTag(tag: Tag){
    if (tag.value == "" && tag.position > 1) {  
      tag.name = '<div style="margin-left:' + (tag.position - 1) * 40 + 'px;">' + tag.name + '</div>';
    }
    if (tag.value != "" && tag.position > 1) {  
      tag.value = '<div style="margin-left:' + (tag.position - 1)* 40 + 'px;">' + tag.value + '</div>';
    }
  }

  updateTag(tag: Tag){
    this.renderTag(tag);
    let commentOperation:Observable<Tag[]>;
    //console.log(tag);
    this.tagService.updateTag(tag).subscribe(
      () => {
      }, 
      err => {
        console.log(err);
      });
  }

  deleteTag(tag){
    let commentOperation:Observable<Tag[]>;
    if(confirm("Are you sure to delete this selected item from '" + tag.value + "'?")) {
      this.tagService.deleteTag(tag._id).subscribe(
        () => {
          //					this.model = new Tag('', '', '', '');
          this.setFirstPage();
          this.open();
        },
        err => {
          console.log(err);
        });
    }
  }

  public selectTag( tag: any, i: number) {
    tag.rank = i + 1;
    this.selectedIndex = i;
    this.selectedTag =  tag; 
    this.setMessage(this.selectedTag);
  }

  public setMessage(tag: any) {
    //this.message = " { \"rank\" : \"" + tag.rank + "\", \"loc\" : { \"x\" : \"" + tag.loc.x + "\", \"y\" : \"" + tag.loc.y + "\" }, \"tag\" : \"" + tag.hashTag + "\", \"source\" : \"" +  tag.source + "\",  \"value\" : \"" + tag.value + "\", \"timestamp\" : \""+tag.insertDate +"\" } "; 
    this.message = " { \"rank\" : \"" + tag.rank + "\", \"loc\" : { \"x\" : \"47.60\", \"y\" : \"122.33\" }, \"tag\" : \"" + tag.hashTag + "\", \"source\" : \"" +  tag.source + "\",  \"value\" : \"" + tag.value + "\", \"timestamp\" : \""+tag.insertDate +"\" } "; 
  }

  keyDown(event: any) {
    switch (event.keyCode) {
      case 38: 
        this.onUp();
        //event.preventDefault();
        break;
      case 40:
        this.onDown()
        //event.preventDefault();
        break;
      case 13:
        //this.setFirstPage()
        this.submitTag();
        event.preventDefault();
        break;
      case 9:
        if(event.shiftKey) { 
          this.selectedTag.position = this.selectedTag.position - 1;
        } else {
          this.selectedTag.position = this.selectedTag.position + 1;
        }
        this.renderTag(this.selectedTag);
        event.preventDefault();
        break;
    }
    return;
  }

  public onDown() {
    if(this.selectedIndex < this.tags.length - 1)
    {
      this.selectedTag = this.tags[++this.selectedIndex];
      this.setMessage(this.selectedTag);
    }
  }

  public onUp() {
    if(this.selectedIndex > 0)
    {
      this.selectedTag = this.tags[--this.selectedIndex];
      this.setMessage(this.selectedTag);
    }
  }

  substringOf(source: string) {
    var i1 = source.indexOf( "https://" );
    var si = 8;
    if (i1 < 0)
    {
      i1 =  source.indexOf( "http://" );
      si = 7;
    }

    if(i1 >= 0)
    {
      var i2 = source.indexOf(  "/", i1 + si );
      if(i2 > 0)
      {
        var s = source.substring(i1 + si, i2);
        return s;
      }	
    }
    return source;
  }

  editTag(tag: any) {
    //this.umodel.edit =  !this.umodel.edit;
    this.umodel = new Tag(tag.hashTag, tag.source, tag.value, tag.userId);
    tag.edit = !tag.edit;
  }

  cancelUpdate(tag: Tag) {
    tag.hashTag = this.umodel.hashTag;
    tag.source = this.umodel.source;
    tag.value = this.umodel.value;
    tag.insertDate = this.umodel.insertDate;
    tag.edit = false;
  }

  refIndex(source: string): number {
    return this.utags.indexOf(source) + 1;
  }

  //pagination for table
  setFirstPage() {
    this.pageDirection = 0;
    this.loadTags(() => {
      this.currentPage = 1;
      if(this.tags.length > 0) {
        this.selectedText = this.tags[this.tags.length - 1].value;
        this.utags = Array.from(new Set(this.tags.map((item) => item.source))); 
      }
    });
  }

  setPreviousPage() {
    this.pageDirection = 1;
    this.loadTags(() => {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    });
  }

  setNextPage() {
    this.pageDirection = 2;
    this.loadTags(() => {
      if (this.currentPage < this.pageCount) {
        this.currentPage++;
      }
    });
  }

  setLastPage () {
    this.pageDirection = 3;
    this.loadTags( () => {
      this.currentPage = this.pageCount;
    });
  }

  setPageVisible() {
    this.selectedIndex = (this.currentPage - 1) * this.pageSize;
    var end = this.currentPage * this.pageSize
    for (let i = 0; i < this.tags.length; i++) {
      this.tags[i].show = false;
      if(i >= this.selectedIndex && i < end) {
        this.tags[i].show = true;
      } 
    }
    this.selectedTag = this.tags[this.selectedIndex];
    if (this.selectedTag) {
      this.selectedTag.rank = this.selectedIndex + 1;
      this.setMessage(this.selectedTag);
    }
  }

  setMe(element) {
    var s_height = element.scrollHeight;
    element.setAttribute('style','height:'+s_height+'px');
  }

  selectAllTags() {
    for (let i = 0; i < this.tags.length; i++) {
      if(!this.selectAll) {
        this.tags[i].checked = true;
      }
      else {
        this.tags[i].checked = false;
      }

    }
  }

  search() {
    //		if(this.loggedInUser === undefined) {
    this.setFirstPage();
    //		} else {
    //			this.router.navigate(['admin']);
    //		}

  }

  editDoc(tag: any) {
    this.saveTopic();
    this.router.navigate(['/admin/edit'],  { queryParams: { h : tag.hashTag}});
  }

  flash(msg,duration) {
    var el = document.createElement("div");
    el.setAttribute("style","position:absolute;top:45%;left:45%;background-color: mediumseagreen; border: none; color: white; padding: 10px; text-align: center; text-decoration: none; display: inline-block; font-size: 16 px; font-family:arial; margin: 4px 2px; cursor: pointer; border-radius: 8px;");
    //el.setAttribute("class","button");
    el.innerHTML = msg;
    setTimeout(function(){
      el.parentNode.removeChild(el);
    },duration);
    document.body.appendChild(el);
  }

  //TODO: use javascript
  ngUpdateTopicAndNavigate() {
    this.updateTopic();
    location.replace("https://tst.tagndoc.com/admin/redirect?h="+this.topic.hashTag+"&i="+this.topic.ID+"&u=edit");
  }

  viewLatestDoc() {
    if(this.topic.value == "") {
      this.updateTopic();
    }
    location.replace("https://tst.tagndoc.com/admin/redirect?h="+this.topic.hashTag+"&i="+this.topic.ID+"&u=edit");
  }

  flashConfirm(msg) {
    var e = document.createElement("div");
    e.setAttribute("id", "flash");
    e.setAttribute("style","position:absolute;top:1%;left:35%;text-align:center; border:1px; border-radius:8px; padding:25px; width:360px; background-color:lightgrey;");

    var el = document.createElement("div");
    el.setAttribute("style","background-color:lightgrey; border:1px; color: grey; padding: 10px; text-align: center; text-decoration: none; display: inline-block; font-size: 16 px; font-family:arial; margin: 4p x 2px; cursor: pointer; border-radius : 8px;");
    el.innerHTML = msg;
    e.appendChild(el);

    var br = document.createElement("br");
    var br1 = document.createElement("br");
    e.appendChild(br);
    e.appendChild(br1);
    var ele = document.createElement("div");
    ele.setAttribute("style","background-color:white; border:1px; padding: 10px; text-align: center; text-decoration: none; display: inline-block; font-size: 16 px; font-family:arial; margin: 4p x 2px; cursor: pointer; border-radius: 8px;");
    ele.setAttribute("style","display:inline-block;");
    e.appendChild(ele);

    var bOk = document.createElement("div");
    bOk.setAttribute("style","background-color:mediumseagreen; border:1px; color: white; padding: 10px; text-align: center; text-decoration: none; display: inline-block; font-size: 16 px; font-family:arial; margin: 4p x 2px; cursor: pointer; border-radius: 8px;");
    bOk.innerHTML = "Ok";
    bOk.setAttribute("onclick", "(function() {e = document.getElementById('flash'); e.parentNode.removeChild(e); jsUpdateTopicAndNavigate();})();");
    ele.appendChild(bOk);

    var sp = document.createElement("div");
    sp.setAttribute("style","color: white; padding: 10px; text-align: center; text-decoration: none; display: inline-block; font-size: 16 px; font-family:arial; margin: 4p x 2px; cursor: pointer; border-radius: 8px;");
    ele.appendChild(sp);

    var bCancel = document.createElement("div");
    bCancel.setAttribute("style","background-color:orangered; border:1px; color: white; padding: 10px; text-align: center; text-decoration: none; display: inline-block; font-size: 16 px; font-family:arial; margin: 4p x 2px; cursor: pointer; border-radius: 8px;");
    bCancel.innerHTML = "Cancel";
    bCancel.setAttribute("onclick", "(function() {e = document.getElementById('flash'); e.parentNode.removeChild(e);})();");
    ele.appendChild(bCancel);

    var h = document.getElementById('textbox');
    h.appendChild(e);
  }

  editLatestDoc(model: any) {
    this.flashConfirm("Are you sure to overwrite the latest document on topic '" + model.hashTag + "'?");
  }


  saveTopic() {
    //let elem: Element = document.getElementById("textbox")
    this.topic.value = document.getElementById("textbox").innerHTML; //Text;
    this.topic.email = this.theUser;
    this.topicService.addTopic(this.topic).subscribe(
      () => {
      },
      err => {
        console.log(err);
      });
  }

  open() {
    this.topicService.filterTopics(this.topic.hashTag, "", "", "", this.theUser)
      .subscribe(
        topics => {
          this.topics = topics;
          if(this.topics !== undefined) {
            this.topic = this.topics[0];
          }
        },
        err => {
          console.log(err);
        });
  }


  updateTopic() {
    this.topic.value = document.getElementById("textbox").innerHTML; //Text;
    this.topic.email = this.theUser;
    this.topicService.updateTopic(this.topic).subscribe(
      () => {
      },
      err => {
        console.log(err);
      });
  }
  home() {
    //this.router.navigate(['/admin/editlatest'],  { queryParams: { h : tag.hashTag}});
    this.router.navigate(['/admin/account']);
  }

  exportTopic(topic: any) {
    this.router.navigate(['/admin/export'],  { queryParams: { h : this.topic.hashTag, i : topic.ID}});
  }

  updateTopicName(){
    if (this.model.hashTag === "" || this.model.hashTag.toLowerCase() === "untitled topic") {
      return;
    }

    this.topic = new Topic('', '', '');
    this.topic.hashTag = this.model.hashTag;
    this.topic.email = this.theUser;
    this.topicService.addTopic(this.topic).subscribe(
      () => {
      },
      err => {
        console.log(err);
      });
  }

  //TODO: Update all the tags with topic change
  updateTagsTopicName(){
    this.tagService.updateTagsTopicName(this.topic.hashTag, this.model.hashTag).subscribe(
      () => {
      },
      err => {
        console.log(err);
      });
    this.updateTopicName();
    this.flash(this.topic.hashTag + " is saved!", 1000);
  }

  renameTopic(){
    if (this.model.hashTag === "" || this.model.hashTag.toLowerCase() === "untitled topic") {
      return;
    }

    this.topic.value = this.model.hashTag;
    this.topic.email = this.theUser;
    this.topic.ID = this.model.id;
    this.topicService.renameTopic(this.topic).subscribe(
      () => {
      },
      err => {
        console.log(err);
      });
  }

  archiveTopic(topic: Topic){
    if(confirm("Do you want to archive " + topic.hashTag + "?")) {
      let commentOperation:Observable<Topic[]>;
      this.topicService.archiveTopic(topic).subscribe(
        () => {
          this.home();
        },
        err => {
          console.log(err);
        });
    }
  }

  //this.router.navigate(['/admin/redirect'],  { queryParams: { h : tag.hashTag, i : tag.id, u : "doc"}});

  rankup(i: number){
    if (i > 1) {
      var t1 = this.tags[i];
      t1.rank = t1.rank - 1;
      this.rankTag(t1)

      var t = this.tags[i].rank;
      this.tags[i].rank = this.tags[i-1].rank;
      this.tags[i-1].rank = t;

      var tag = this.tags[i]; 
      this.tags[i] = this.tags[i-1]; 
      this.tags[i-1] = tag;
    }
  }

  rankdown(i: number){
    if (i < this.tags.length - 1) {
      var t1 = this.tags[i];
      t1.rank = t1.rank + 1;
      this.rankTag(t1)

      var t = this.tags[i].rank;
      this.tags[i].rank = this.tags[i+1].rank;
      this.tags[i+1].rank = t;

      var tag = this.tags[i]; 
      this.tags[i] = this.tags[i+1]; 
      this.tags[i+1] = tag;
    }
  }

  rankTag(tag: Tag){
    this.tagService.rankTag(tag).subscribe(
      () => {
      },
      err => {
        console.log(err);
      });
  }
}




// WEBPACK FOOTER //
// ./src/app/admin/chat/chat.component.ts